import { useRef } from 'react';

export const useUniqueId = () => {
	const ref = useRef(`id_${Math.floor(Math.random() * 0xffffffff)}`);

	return ref.current;
};
